module.exports = __webpack_public_path__ + "img/round.810c3d5b.png";